/**
 * @file features/grids/gridsInitialState.ts
 * @description Contains the ininitial state for the gridReducer.
 */

import { TAllGrids } from "./types";

const gridsInitialState: TAllGrids = {};
export default gridsInitialState;